import { render, staticRenderFns } from "./ShortNameEditor.vue?vue&type=template&id=f0c3eff6&"
import script from "./ShortNameEditor.vue?vue&type=script&lang=js&"
export * from "./ShortNameEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports